import { jArticleListSchema, jArticleLittleSchema, jArticleViewSchema } from './article';
import { z } from 'zod';

export const jSurveyDateListSchema = jArticleListSchema.extend({
    dates: z.array(z.string()),
    dateStart: z.string().nullable(),
    dateEnd: z.string(),
});
export type jSurveyDateList = z.infer<typeof jSurveyDateListSchema>;

export const jSurveyDateViewSchema = jArticleViewSchema.and(jSurveyDateListSchema).and(
    z.object({
        surveyObjectLink: z.array(jArticleLittleSchema),
    }),
);
export type jSurveyDateView = z.infer<typeof jSurveyDateViewSchema>;
